import React, {createContext, useState} from "react";
import PMSDoctorServices from "../../services/pms_services/PMSDoctorServices";
import Notification from "../../components/common/Notification";

export const PMSDoctorContext = createContext("PMSDoctorContext");

const PMSDoctorContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [totalElements, setTotalElements] = useState(0);
    const [doctors, setDoctors] = useState([]);
    const [doctor, setDoctor] = useState(null);

    const handleError = (error) => {
        setLoading(false);
        let _error = "Something went wrong.";
        if (error.message === "Network Error") _error = error.message;
        if (error.response && error.response.data) _error = error.response.data.message;
        setErrorMsg(_error);
        Notification("error", "ERROR", `${_error}`);
        return false;
    };

    const getAllDoctorsByPharmacyId = async (pharmacyId, params) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSDoctorServices.getAllDoctorsByPharmacyId(pharmacyId, params);
            setDoctors(res.data.content);
            setTotalElements(res.data.totalElements);
            setLoading(false);
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const getDoctorById = async (pharmacyId, id) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSDoctorServices.getDoctorById(pharmacyId, id);
            setDoctor(res.data);
            setLoading(false);
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const getDoctorSelfProfileById = async (id) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSDoctorServices.getDoctorSelfProfileById(id);
            setDoctor(res.data);
            setLoading(false);
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const createDoctor = async (pharmacyId, data) => {
        try {
            setLoading(true);
            await PMSDoctorServices.createDoctor(pharmacyId, data);
            setLoading(false);
            Notification("success", "SUCCESS", "Doctor created successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const updateDoctorById = async (id, pharmacyId, data) => {
        try {
            setLoading(true);
            await PMSDoctorServices.updateDoctorById(id, pharmacyId, data);
            setLoading(false);
            Notification("success", "SUCCESS", "Doctor updated successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const deleteDoctorById = async (id) => {
        try {
            setLoading(true);
            await PMSDoctorServices.deleteDoctorById(id);
            setLoading(false);
            Notification("success", "SUCCESS", "Doctor deleted successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    const updateDoctorSelfProfile = async (data) => {
        try {
            setLoading(true);
            await PMSDoctorServices.updateDoctorSelfProfile(data);
            setLoading(false);
            Notification("success", "SUCCESS", "Profile updated successfully");
            return true;
        } catch (error) {
            return handleError(error);
        }
    };

    return (
        <PMSDoctorContext.Provider
            value={{
                loading,
                errorMsg,
                totalElements,
                doctors,
                doctor,
                getAllDoctorsByPharmacyId,
                getDoctorById,
                getDoctorSelfProfileById,
                createDoctor,
                updateDoctorById,
                deleteDoctorById,
                updateDoctorSelfProfile,
            }}
        >
            {children}
        </PMSDoctorContext.Provider>
    );
};

export default PMSDoctorContextProvider;
